import React from "react"
import {useTranslation} from "react-i18next"
import {ExclamationTriangleIcon} from "@heroicons/react/24/outline"
import {twMerge} from "tailwind-merge"

import {APhoneField, APhoneFieldDnclStatusEnum} from "../services/types.generated.ts"
import {getWorstDnclStatus} from "../utils/dncl.ts"
import {Tooltip, TTooltipButtonProps} from "./Tooltip.tsx"

type EntityWithPhones = {
  phone_number?: APhoneField
  organization_phone_number?: APhoneField
  additional_phone_number?: APhoneField
  anonymized?: boolean
}

export const DnclWarning: React.FC<{entity: EntityWithPhones}> = ({entity}) => {
  const {t} = useTranslation()
  const status = getWorstDnclStatus(entity)

  if (status !== APhoneFieldDnclStatusEnum.Listed && status !== APhoneFieldDnclStatusEnum.Failed) {
    return null
  }

  const isListed = status === APhoneFieldDnclStatusEnum.Listed

  return (
    <Tooltip Button={isListed ? ListedTooltipButton : FailedTooltipButton}>
      <div className={"max-w-[400px] rounded-lg bg-cr-black px-4 py-2 text-sm whitespace-pre-line text-cr-white"}>
        {isListed ? t("Prospects_Dncl_Listed_Warning") : t("Prospects_Dncl_Failed_Warning")}
      </div>
    </Tooltip>
  )
}

const ListedTooltipButton = React.forwardRef<HTMLDivElement, TTooltipButtonProps>(({open}, ref) => {
  return (
    <div
      className={twMerge([
        "relative top-[1px] flex h-7 w-7 items-center justify-center rounded-full bg-transparent text-cr-red transition-all",
        open && "bg-cr-grey-5",
      ])}
      ref={ref}
    >
      <ExclamationTriangleIcon className={"w-5"} />
    </div>
  )
})
ListedTooltipButton.displayName = "ListedTooltipButton"

const FailedTooltipButton = React.forwardRef<HTMLDivElement, TTooltipButtonProps>(({open}, ref) => {
  return (
    <div
      className={twMerge([
        "relative top-[1px] flex h-7 w-7 items-center justify-center rounded-full bg-transparent text-cr-yellow transition-all",
        open && "bg-cr-grey-5",
      ])}
      ref={ref}
    >
      <ExclamationTriangleIcon className={"w-5"} />
    </div>
  )
})
FailedTooltipButton.displayName = "FailedTooltipButton"
